require('./em-divider.scss');

module.exports = {
  transclude: true,
  bindings: {},
  template: `
  <div class="em-divider"></div>
  `,
};
